export interface WorkflowStepData {
  id: string;
  label: string;
  subtitle?: string;
  description: string;
  model?: string;
  tables?: string[];
  color: string; // tailwind color key
}

export interface WorkflowData {
  id: string;
  title: string;
  description: string;
  steps: WorkflowStepData[];
}

export const workflows: WorkflowData[] = [
  {
    id: "cv-pipeline",
    title: "Pipeline d'analyse CV",
    description: "De l'import du CV jusqu'au ranking final, chaque candidature passe par une chaine de traitement automatisee.",
    steps: [
      {
        id: "import",
        label: "Import CV",
        subtitle: "Upload fichier",
        description: "L'utilisateur uploade le CV (PDF/image) d'un candidat. Le fichier est stocke et un depot est cree dans la base.",
        tables: ["depots", "candidats", "societes_files"],
        color: "blue",
      },
      {
        id: "extraction",
        label: "Extraction texte",
        subtitle: "Infomaniak Vision",
        description: "Le contenu du CV est extrait par OCR via Infomaniak Vision API. Le texte brut est stocke dans depots.texte_extrait.",
        model: "Infomaniak Vision",
        tables: ["depots"],
        color: "cyan",
      },
      {
        id: "anonymisation",
        label: "Anonymisation",
        subtitle: "Infomaniak LLM",
        description: "Le texte est anonymise directement a l'extraction (suppression nom, genre, age, photo) via un LLM Infomaniak. Le resultat est stocke dans depots.texte_extrait.",
        model: "Infomaniak LLM",
        tables: ["depots"],
        color: "teal",
      },
      {
        id: "scoring",
        label: "Scoring IA",
        subtitle: "Gemini / Dual",
        description: "Le CV anonymise est analyse par un ou deux modeles IA (Gemini et/ou Infomaniak) selon le mode configure. Un score 0-100 et un detail par critere sont produits.",
        model: "Gemini Flash / Infomaniak Dual",
        tables: ["analyses", "appels_offres"],
        color: "violet",
      },
      {
        id: "decision",
        label: "Decision",
        subtitle: "Auto + Manuel",
        description: "En fonction des seuils configures sur l'AO (shortlist >= 75, consider >= 60), une decision automatique est attribuee. L'utilisateur peut la modifier manuellement.",
        tables: ["analyses"],
        color: "amber",
      },
      {
        id: "ranking",
        label: "Ranking",
        subtitle: "Classement final",
        description: "Les candidats sont classes par score global. Les societes sont evaluees en agregant les scores de leurs candidats avec les notes complementaires (prix, durabilite, qualite).",
        tables: ["analyses", "ao_societe_notes"],
        color: "emerald",
      },
    ],
  },
  {
    id: "ao-lifecycle",
    title: "Cycle de vie d'un Appel d'Offres",
    description: "De la creation a l'adjudication, un AO passe par plusieurs phases de configuration et d'analyse.",
    steps: [
      {
        id: "creation",
        label: "Creation",
        subtitle: "Nouvel AO",
        description: "Un administrateur cree un nouvel appel d'offres avec titre, reference et dates cles.",
        tables: ["appels_offres"],
        color: "blue",
      },
      {
        id: "criteres",
        label: "Criteres",
        subtitle: "Grille d'evaluation",
        description: "Configuration des criteres d'evaluation avec ponderations (competences, certifications) et des grilles d'evaluation detaillees.",
        tables: ["evaluations", "criteres_evaluation"],
        color: "indigo",
      },
      {
        id: "config-ia",
        label: "Config IA",
        subtitle: "Modele & prompt",
        description: "Selection du modele IA (Gemini, Infomaniak, dual), du prompt template et des seuils de scoring.",
        tables: ["appels_offres", "prompt_templates"],
        color: "violet",
      },
      {
        id: "acces",
        label: "Gestion acces",
        subtitle: "Permissions",
        description: "Attribution des droits de lecture, ecriture et administration aux utilisateurs pour cet AO.",
        tables: ["ao_access_permissions"],
        color: "orange",
      },
      {
        id: "import",
        label: "Import CV",
        subtitle: "Candidatures",
        description: "Import des CV des candidats, extraction texte et anonymisation automatique.",
        tables: ["depots", "candidats"],
        color: "cyan",
      },
      {
        id: "analyses",
        label: "Analyses",
        subtitle: "Scoring IA",
        description: "Lancement des analyses IA sur chaque depot. Scoring, decision et rating automatiques.",
        tables: ["analyses"],
        color: "purple",
      },
      {
        id: "adjudication",
        label: "Adjudication",
        subtitle: "Decision finale",
        description: "Evaluation finale des societes avec notes complementaires (prix, durabilite, qualite). Classement et selection du soumissionnaire retenu.",
        tables: ["ao_societe_notes", "appels_offres"],
        color: "emerald",
      },
    ],
  },
  {
    id: "scoring-model",
    title: "Modele de scoring et decision",
    description: "Le systeme de notation combine analyse IA et evaluation manuelle avec des garde-fous.",
    steps: [
      {
        id: "ia-score",
        label: "Score IA",
        subtitle: "0-100 pts",
        description: "Le modele IA attribue un score global 0-100 base sur l'adequation du CV aux criteres de l'AO. Un cap a 55 est applique si le modele ne fournit pas de justification concrete.",
        model: "Gemini / Infomaniak",
        color: "blue",
      },
      {
        id: "consensus",
        label: "Consensus dual",
        subtitle: "2 modeles",
        description: "En mode dual, deux modeles IA analysent independamment. Le score final est la moyenne ponderee. Les ecarts importants sont signales.",
        model: "Gemini + Infomaniak",
        color: "violet",
      },
      {
        id: "seuils",
        label: "Seuils decision",
        subtitle: "Shortlist / Consider / Reject",
        description: "Shortlist (>= 75%) : candidat retenu pour entretien. Consider (>= 60%) : candidat a examiner. Reject (< 60%) : candidat non retenu.",
        color: "amber",
      },
      {
        id: "manual",
        label: "Ajustement",
        subtitle: "Rating A/B/C",
        description: "L'evaluateur peut ajuster la decision, attribuer un rating A/B/C et ajouter un commentaire. Les exclusions manuelles sont tracees.",
        tables: ["analyses"],
        color: "emerald",
      },
    ],
  },
];
